import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=37df33dc&scoped=true"
import script from "./videoDialog.vue?vue&type=script&lang=js"
export * from "./videoDialog.vue?vue&type=script&lang=js"
import style0 from "./videoDialog.vue?vue&type=style&index=0&id=37df33dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df33dc",
  null
  
)

export default component.exports